import { createClient } from '@supabase/supabase-js';
import { geschuetztesFetch } from './schreibschutz';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

if (!url || !key) {
  throw new Error('VITE_SUPABASE_URL und VITE_SUPABASE_PUBLISHABLE_KEY müssen gesetzt sein.');
}

/**
 * Einladungs- und Passwort-Links tragen type=invite bzw. type=recovery im URL-Fragment.
 * Muss vor createClient gelesen werden, weil der Client das Fragment danach entfernt.
 */
export const PASSWORT_SETZEN = typeof window !== 'undefined' && /type=(invite|recovery)/.test(window.location.hash);

export const supabase = createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
  // Ansicht als (BR-06): schreibende Anfragen werden im Frontend abgewiesen
  global: { fetch: geschuetztesFetch },
});

export interface Mandant {
  mandant_id: string;
  name: string;
  kurzname: string;
  gruppen: string[];
  /** Steuert u. a. die Wartetexte beim Einlesen (neutral, maritim, grosshandel, handwerk) */
  branche?: string;
}

/** Ergebnis von public.mein_zugang: ob die Zugriffsrichtlinie des Mandanten erfüllt ist */
export interface Zugang {
  ok: boolean;
  grund: 'mfa' | 'sitzung' | 'ip' | 'kein_mitglied' | 'fehler' | null;
  mfa_pflicht: boolean;
  aal: 'aal1' | 'aal2';
  sitzung_ende: string | null;
  ip: string | null;
  /** Sitzung war bestätigt, das MFA-Intervall ist abgelaufen */
  mfa_erneut?: boolean;
  mfa_intervall_stunden?: number | null;
  /** Zeitpunkt der nächsten fälligen MFA-Bestätigung */
  mfa_faellig?: string | null;
  /** null = Bestätigung wird nicht auf dem Gerät gemerkt */
  mfa_merken_stunden?: number | null;
  /** Zugang über ein gemerktes Gerät statt Code in dieser Sitzung */
  mfa_ueber_geraet?: boolean;
  /** Passkeys als zweiter Faktor im Mandanten erlaubt */
  passkey_erlaubt?: boolean;
  /** Adressen (RP-IDs), für die der Benutzer Passkeys hinterlegt hat */
  passkey_rps?: string[];
}

export interface Kunde {
  id: string;
  kundennummer: string;
  firma: string;
  ort: string | null;
  email: string | null;
  aktiv: boolean;
}
